<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col cols="12">
                    <BaseCard
                        title="PO Receive Entry"
                        icon="mdi-truck-delivery"
                        vCardTextClass="pa-2"
                    >
                        <v-row>
                            <v-col md="3" cols="12">
                                <v-card elevation="0" border rounded="lg" class=" h-100">
                                    <div class="d-flex align-center pa-2">
                                        <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                                            <v-icon size="20">mdi-information-outline</v-icon>
                                        </v-avatar>
                                        <div>
                                            <div class="text-subtitle-1 font-weight-medium">Main details</div>
                                            <div class="text-caption text-medium-emphasis">Provide main information</div>
                                        </div>
                                    </div>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-autocomplete
                                                label="Purchase Order"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="pur_order_master_id.value.value"
                                                :items="filteredPurRequisitionList"
                                                :item-title="(item) => `${item.code}`"
                                                item-value="id"
                                                @update:modelValue="onRequisitionChange"
                                                :error-messages="pur_order_master_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Purchase Order
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                label="Warehouse"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="warehouse_id.value.value"
                                                :items="getWarehouseList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="warehouse_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Warehouse
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            
                                            <v-autocomplete
                                                label="Purpose/Project"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="purpose_id.value.value"
                                                :items="getPurposeList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="purpose_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Purpose/Project
                                                    <span class="text-red-accent-4"></span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                label="Supplier Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="supplier_id.value.value"
                                                :items="getSupplierList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="supplier_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Supplier Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Receive Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="receive_date.value.value"
                                                :error-messages="receive_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Shipping Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="shipping_date.value.value"
                                                :error-messages="shipping_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Purchase Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purchase_date.value.value"
                                                :error-messages="purchase_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>

                                            <v-autocomplete
                                                label="Purchase Type"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="purchase_type.value.value"
                                                :items="types"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="purchase_type.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Purchase Type
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-textarea
                                                label="Shipping Address"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="shipping_address.value.value"
                                                :error-messages="shipping_address.errorMessage.value"
                                                autocomplete="off"
                                                rows="1"
                                                clearable
                                            ></v-textarea>

                                            <v-text-field
                                                label="Rfq By"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by.value.value"
                                                :error-messages="purOrder_by.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="Rfq By Mobile"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by_mobile.value.value"
                                                :error-messages="purOrder_by.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="Rfq By Email"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by_email.value.value"
                                                :error-messages="purOrder_by_email.errorMessage.value"
                                                :disabled="true"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                </v-card>
                            </v-col>
                            <v-col class="pl-0" md="9" cols="12">
                                <v-card elevation="0" border rounded="lg">
                                    <div class="d-flex align-center pt-4 px-4">
                                        <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                                            <v-icon size="20">mdi-format-list-bulleted</v-icon>
                                        </v-avatar>
                                        <div>
                                            <div class="text-subtitle-1 font-weight-medium">Receive items</div>
                                            <div class="text-caption text-medium-emphasis">Search and add products to this receipt</div>
                                        </div>
                                    </div>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >
                                    <v-row v-if="landedCostSummary" class="pt-2">
                                      <v-col cols="12">
                                        <v-alert type="success" variant="tonal" density="compact">
                                          <div class="font-weight-bold mb-1">Approved Landed Cost: {{ landedCostSummary.code || '-' }}</div>
                                          <div>Other Expense: {{ $numberFormat(landedCostSummary.total_landed_cost || 0) }} | Total Inventory Expense: {{ $numberFormat(landedCostSummary.total_expense || 0) }} | Profit/AIT/VAT: {{ landedCostSummary.profit_percent || 0 }}% / {{ landedCostSummary.ait_percent || 0 }}% / {{ landedCostSummary.vat_percent || 0 }}%</div>
                                        </v-alert>
                                      </v-col>
                                    </v-row>
                                    <v-row class="pt-2 justify-center">
<!--                                        <v-col cols="8">-->
<!--                                            <v-autocomplete-->
<!--                                                label="Search Product Name"-->
<!--                                                variant="outlined"-->
<!--                                                density="compact"-->
<!--                                                bg-color="grey-lighten-4"-->
<!--                                                v-model="product_id.value.value"-->
<!--                                                :items="getProductMapList"-->
<!--                                                :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"-->
<!--                                                item-value="product_id"-->
<!--                                                :error-messages="product_id.errorMessage.value"-->
<!--                                                autocomplete="off"-->
<!--                                                @update:model-value="addCart"-->
<!--                                                @keydown.enter="addCart"-->
<!--                                                clearable-->
<!--                                            -->
<!--                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"-->
<!--&gt;</v-autocomplete>-->

<!--                                            <input-->
<!--                                                v-model="pur_order_master_id.value.value"-->
<!--                                                type="hidden"-->
<!--                                            />-->
<!--                                        </v-col>-->

                                        <!-- <v-col cols="1">
                                            <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                                        </v-col> -->
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                        <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                                            <v-card elevation="0" class="overflow-x-auto">
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="max-height: 600px ; overflow-y: scroll"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-left" style="width: 10%">
                                                        Code
                                                        </th>
                                                        <th class="text-left" style="width: 25%">
                                                        Product Name
                                                        </th>
                                                         <th class="text-center" style="width: 15%">Unit</th>
                                                        <th class="text-center" style="width: 15%">
                                                        Lot No.
                                                        </th>
                                                        <th class="text-center" style="width: 15%">
                                                        Expire Date
                                                        </th>
                                                        <th class="text-center" style="width: 15%">  Quantity </th>
                                                        <th v-if="isFreeItem" class="text-center" style="width: 15%">  Free Quantity </th>
                                                       
                                                        <th class="text-center" style="width: 15%;display:none">Pur. Rate</th>
                                                        <th class="text-center" style="width: 15%;">Landed / Unit</th>
                                                        <th class="text-center" style="width: 15%;">Inventory Cost</th>
                                                        <th class="text-center" style="width: 15%;">Sales Rate (With VAT)</th>
                                                        <th class="text-center" style="width: 15%;display:none" >
                                                        Sub Total
                                                        </th>
                                                      <th class="text-left" style="min-width:130px">Standard Purity (%)</th>
                                                      <th class="text-left" style="min-width:130px">Present Purity (%)</th>
                                                        <th class="text-center" style="width: 10%">
                                                        Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in cart"
                                                        v-if="cart.length > 0"
                                                        :key="index"
                                                    >
                                                        <td class="text-center">{{ index + 1 }}</td>
                                                        <td class="text-left" style="min-width: 120px">
                                                          {{ item.code }}
                                                        </td>
                                                        <td
                                                        class="text-left"
                                                        style="min-width: 140px"
                                                        >
                                                        {{ item.product_name }}
                                                        </td>
                                                         <td class="text-center">
                                                        {{ item.unit_name }}
                                                        </td>
                                                          <td class="text-right">
                                                            <v-text-field
                                                              :reverse="false"
                                                              controlVariant="stacked"
                                                              label=""
                                                              style="width: 100px"
                                                              type="text"
                                                              hide-details="auto"
                                                              :hideInput="false"
                                                              :inset="false"
                                                              density="compact"
                                                              variant="outlined"
                                                              bg-color="grey-lighten-4"
                                                              v-model="item.lot_no"
                                                    
                                                              @blur="item.lot_no"
                                                            ></v-text-field>
                                                          </td>
                                                      <td class="text-right">
                                                        <v-date-input
                                                            input-format="dd/mm/yyyy"
                                                            density="compact"
                                                            prepend-icon=""
                                                            hide-details="auto"
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model="item.expiry_date"
                                                            style="width: 130px"
                                                            autocomplete="off"
                                                            clearable
                                                        ></v-date-input>
                                                      </td>
                                                        <td class="text-right">
                                                          <v-text-field
                                                              :reverse="false"
                                                              controlVariant="stacked"
                                                              label=""
                                                              :hideInput="false"
                                                              hide-details="auto"
                                                              :inset="false"
                                                              :min="1"
                                                              type="number"
                                                              style="width: 80px"
                                                              density="compact"
                                                              variant="outlined"
                                                              bg-color="grey-lighten-4"
                                                              v-model="item.qty"
                                                              :error-messages="
                                                              item.qty < 1
                                                                  ? 'Quantity must be greater than 0'
                                                                  : ''
                                                              "
                                                              @update:model-value="
                                                              item.total = item.qty * item.rate
                                                              "
                                                              @blur="item.total = item.qty * item.rate"
                                                          ></v-text-field>
                                                        </td>

                                                        <td class="text-right" style="display:none">
                                                           <v-text-field
                                                              :reverse="false"
                                                              controlVariant="stacked"
                                                              style="width:100px;"
                                                              label=""
                                                              :hideInput="false"
                                                              :inset="false"
                                                              :min="1"
                                                              type="number"
                                                              density="compact"
                                                              variant="outlined"
                                                              bg-color="grey-lighten-4"
                                                              v-model="item.rate"
                                                              hide-details="auto"
                                                              :error="item.rate < 1"
                                                              :error-messages=" item.qty < 1 ? 'rate must be greater than 0' : '' "
                                                              @update:model-value=" item.total = item.qty * item.rate "
                                                            ></v-text-field>
                                                        </td>
                                                        <td class="text-right py-1">{{ item.other_cost == null ? '-' : $numberFormat(item.other_cost) }}</td>
                                                        <td class="text-right py-1">{{ item.inventory_cost == null ? '-' : $numberFormat(item.inventory_cost) }}</td>
                                                         <td class="text-right py-1">
                                                            <v-text-field
                                                              :reverse="false"
                                                               style="width:100px;"
                                                              controlVariant="stacked"
                                                              label=""
                                                              type="text"
                                                              :hideInput="false"
                                                              hide-details="auto"
                                                              :inset="false"
                                                              density="compact"
                                                              variant="outlined"
                                                              bg-color="grey-lighten-4"
                                                              v-model="item.sales_rate"
                                                    
                                                              @blur="item.sales_rate"
                                                            ></v-text-field>
                                                          </td>
                                                        <td class="text-right" style="display:none">
                                                        {{ this.$numberFormat(item.total) }}
                                                        </td>
                                                        <td
                                                            class="text-left"
                                                            style="white-space: normal"
                                                        >
                                                          {{ item.standard_purity }}
                                                        </td>
                                                        <td class="text-right">
                                                          <v-text-field
                                                              style="width: 100px"
                                                              density="compact"
                                                              variant="outlined"
                                                              hide-details="auto"
                                                              bg-color="grey-lighten-4"
                                                              v-model="item.present_purity"
                                                              @update:model-value="clampPurity(item)"
                                                          ></v-text-field>
                                                        </td>
                                                        <td class="text-center px-1">
                                                          <v-btn
                                                              icon="mdi-delete-outline"
                                                              size="small"
                                                              color="error"
                                                              variant="text"
                                                              @click="removeFromCart(index)"
                                                          ></v-btn>
                                                        </td>
                                                    </tr>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="6" class="text-center">
                                                        <v-skeleton-loader
                                                            type="heading"
                                                            :loading="loading"
                                                        />
                                                        </td>
                                                    </tr>
                                                    <tr v-else>
                                                            <td colspan="13" class="text-center py-8">
                                                                <v-icon size="32" color="primary" class="mb-2">mdi-package-variant-closed</v-icon>
                                                                <div class="text-body-2 text-medium-emphasis">No items added yet</div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card>
                            </v-col>
                        </v-row>
                      <v-divider class="mt-2"></v-divider>
                      <v-card-actions>
                        <v-row align="start">
                          <v-col cols="12" md="8">
                            <v-textarea
                                label="Remarks"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="remarks.value.value"
                                :error-messages="remarks.errorMessage.value"
                                autocomplete="off"
                                rows="3"
                                clearable
                            ></v-textarea>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="d-flex justify-end ga-2">
                              <v-btn color="grey-darken-1" variant="flat" prepend-icon="mdi-content-save-outline" @click="submitForm(0)">draft</v-btn>
                              <v-btn color="primary" variant="flat" prepend-icon="mdi-send-outline" @click="submitForm(1)">Post</v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </BaseCard>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { nextTick, ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
import { getCompanyInfo } from '@/plugins/helpers'
import BaseCard from "@/components/utils/baseCard.vue";
import poLandedCostApi from "@/services/poLandedCostApi";
export default {
  components: {
    BaseCard,
  },
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    isFreeItem:false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    landedCostSummary: null,
    cart: [],
    types: [
      { id: 1, name: "Normal" },
      { id: 2, name: "Urgent" },
    ],
  }),
  watch: {},
  created() {
    // if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    // }
    // if (this.$store.getters.getPurposeList.length === 0) {
      this.$store.dispatch("getPurposeList");
    // }
    // if (this.$store.getters.getSupplierList.length === 0) {
      this.$store.dispatch("getSupplierList");
    // }
    // if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    // }

    //if (this.$store.getters.getReceivablePurchaseOrderList.length === 0) {
      this.$store.dispatch("getReceivablePurchaseOrderList");
    //}
  },
  computed: {
    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getPurposeList() {
      return this.$store.getters.getPurposeList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.$store.getters.getAuthUser.branch_id && item.status == 1
      );
    },
    getSupplierList() {
      return this.$store.getters.getSupplierList;
    },
    filteredPurRequisitionList() {
      const requisitions = this.$store.getters.getReceivablePurchaseOrderList || [];
      return requisitions.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
  },
  methods: {
    clampPurity(item) {

      if (Number.isNaN(item.present_purity) || item.present_purity < 0) {
        item.present_purity = 0;
      } else if (item.present_purity > 100) {
        item.present_purity = 100;
      } else {
        item.present_purity = item.present_purity;
      }
    },
    addCart() {
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.product_id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        code: product.code,
        product_name: product.name,
        lot_no: null,
        expiry_date: null,
        qty: 1,
        free_qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        sales_rate: product.sale_rate,
        rate: product.purchase_rate,
        total: product.purchase_rate,
        standard_purity: product.standard_purity || 0,
        present_purity: product.standard_purity || 0,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
    async onRequisitionChange(selectedId) {
      if (!selectedId) {
        this.warehouse_id.value.value = null;
        this.purpose_id.value.value = null;
        this.shipping_address.value.value = "";
        this.landedCostSummary = null;
        this.cart = [];
        return;
      }

      try {
        this.$store.commit("SET_LOADING", { color: "primary" });
        this.landedCostSummary = null;
        const data = await this.$store.dispatch(
          "getPurOrderById",
          selectedId
        );

        this.warehouse_id.value.value =
          data.warehouse_id || data.warehouse?.id || null;
        this.purpose_id.value.value = data.purpose_id || null;
        this.supplier_id.value.value =
          data.supplier_id || data.supplier?.id || null;
        this.purchase_type.value.value = data.purchase_type
          ? parseInt(data.purchase_type)
          : null;
        this.purchase_date.value.value = data.purchase_date
          ? new Date(data.purchase_date)
          : null;
        this.shipping_date.value.value = data.shipping_date
          ? new Date(data.shipping_date)
          : null;
        this.shipping_address.value.value =
          data.shipping_address ||
          data.warehouse?.address ||
          data.supplier?.address ||
          "";
        this.remarks.value.value = data.remarks || "";
        this.po_master_id.value.value = data.id || null;

        this.cart = [];
        const orderDetails =
          data.pur_order_details || data.purOrderDetails || [];
        const { master: landedCost, costs: costingByProduct }
            = await this.loadLandedCostPricing(selectedId, orderDetails);
        this.landedCostSummary = landedCost ? {
          code: landedCost.code,
          total_landed_cost: Number(landedCost.total_landed_cost || 0),
          total_expense: Number(landedCost.total_expense || 0),
          profit_percent: Number(landedCost.profit_percent || 0),
          ait_percent: Number(landedCost.ait_percent || 0),
          vat_percent: Number(landedCost.vat_percent || 0),
        } : null;

        orderDetails.forEach((item) => {
          const costing = costingByProduct.get(Number(item.product_id)) || {};
          const poSalesRate = Number(item.sales_rate || 0);
          const calculatedSalesRate = Number(costing.price_with_vat || 0);
          this.cart.push({
            product_id: item.product_id,
            code: item.product?.code || "",
            product_name: item.product?.name || "",
            lot_no: item.lot_no,
            qty: item.qty,
            free_qty: item.free_qty,
            unit_id: item.product?.unit_id || item.product?.unit?.id || "",
            unit_name: item.product?.unit?.name || "",
            sales_rate: calculatedSalesRate > 0 ? calculatedSalesRate : poSalesRate,
            rate: item.rate,
            total: item.qty * item.rate,
            other_cost: costing.other_cost == null ? null : Number(costing.other_cost),
            inventory_cost: costing.inventory_cost == null ? null : Number(costing.inventory_cost),
            calculated_sales_rate: costing.price_with_vat == null ? null : Number(costing.price_with_vat),
            standard_purity: item.product?.standard_purity || 0,
            present_purity: item.product?.standard_purity || 0,
          });
        });
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        this.$store.commit("UNSET_LOADING");
        toast.error(error.response?.data?.message || "Failed to load purchase order costing.");
        console.error("Failed to load requisition data:", error);
      }
    },
    async loadLandedCostPricing(poId, orderDetails) {
      const productIds = [...new Set((orderDetails || []).map(item => Number(item.product_id)).filter(Boolean))];
      const responses = await Promise.all(productIds.map(async productId => {
        const response = await poLandedCostApi.productCost(poId, productId);
        return { productId, costing: response.data?.data || response.data || {} };
      }));
      const costs = new Map();
      let master = null;
      responses.forEach(({ productId, costing }) => {
        master = master || costing.master || null;
        costs.set(productId, {
          other_cost: Number(costing.other_cost || 0),
          inventory_cost: Number(costing.inventory_cost || 0),
          sales_price: Number(costing.sales_price || 0),
          price_with_ait: Number(costing.price_with_ait || 0),
          price_with_vat: Number(costing.price_with_vat || 0),
        });
      });
      return { master, costs };
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        purchase_date: yup.date().required().label("Purchase Date"),
        receive_date: yup.date().required().label("Receive Date"),
        shipping_date: yup.date().nullable().label("Shipping Date"),
        warehouse_id: yup.number().positive().integer().required().label("Designation Name"),
        pur_order_master_id: yup.number().positive().integer().required().label("Purchase Order"),
        supplier_id: yup.number().positive().integer().required().label("Supplier Name"),
        shipping_address: yup.string().required().label("shipping Address"),
        purchase_type: yup.string().required().label("purchase_type"),
      }),
    });
    
    const inv_po_receive_masters_id = useField("inv_po_receive_masters_id");
    const shipping_address = useField("shipping_address");
    const shipping_date = useField("shipping_date");
    const receive_date = useField("receive_date");
    const product_id = useField("product_id");
    const purchase_type = useField("purchase_type");
    const pr_status = useField("pr_status");
    const employee_id = useField("employee_id");
    const warehouse_id = useField("warehouse_id");
    const purpose_id = useField("purpose_id");
    const po_master_id = useField("po_master_id");
    const supplier_id = useField("supplier_id");
    const pur_order_master_id = useField("pur_order_master_id");
    const purchase_date = useField("purchase_date");
    const remarks = useField("remarks");
    const purOrder_by = useField("purOrder_by");
    const purOrder_by_mobile = useField("purOrder_by_mobile");
    const purOrder_by_email = useField("purOrder_by_email");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      console.log(values);
      values.status = currentStatus.value;
      values.cart = cart.value;
      values.purchase_date = formattedDate(purchase_date.value.value);

      values.cart = cart.value.map((item) => ({
        ...item,
        expiry_date:formattedDate(item.expiry_date)
      }));

      store
        .dispatch("saveUpdateInvPoReceive", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "po-receive-records" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      inv_po_receive_masters_id,
      product_id,
      purchase_date,
      remarks,
      purchase_type,
      cart,
      purOrder_by,
      purOrder_by_mobile,
      purOrder_by_email,
      pr_status,
      errorMessages,
      employee_id,
      warehouse_id,
      purpose_id,
      po_master_id,
      supplier_id,
      pur_order_master_id,
      buttonText,
      loading,
      shipping_date,
      receive_date,
      shipping_address,
    };
  },

  mounted() {
    this.isFreeItem = getCompanyInfo()?.is_free_item ?? false;
    this.pr_status.value.value = "1";
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.purOrder_by.value.value = user.full_name;
    this.purOrder_by_mobile.value.value = user.mobile;
    this.purOrder_by_email.value.value = user.email;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("getInvPoReceiveById", id)
          .then((data) => {
            this.isEntryMode = false;
            let purOrder = data;

            this.$store.commit("SET_RECEIVABLE_PUR_ORDER_LIST", [data.purordermaster]);

            this.inv_po_receive_masters_id.value.value = purOrder.id;
            this.pur_order_master_id.value.value = purOrder.pur_order_master_id;
            this.purchase_date.value.value = purOrder.purchase_date
            this.receive_date.value.value = purOrder.receive_date
            this.shipping_date.value.value = purOrder.shipping_date
            this.purchase_type.value.value = parseInt(purOrder.purchase_type);
            this.warehouse_id.value.value = purOrder.warehouse.id;
            this.purpose_id.value.value = purOrder.purpose_id;
            this.shipping_address.value.value = purOrder.shipping_address;
            this.product_id.value.value = null;
            this.supplier_id.value.value = purOrder.supplier_id;
            this.cart.value = [];

            // Insert items one by one
            (purOrder.inv_po_receive_details || []).forEach((item) => {
              this.cart.push({
                product_id: item.product_id,
                code: item.product?.code || "",
                product_name: item.product?.name || "",
                lot_no: item.lot_no,
                expiry_date: item.expiry_date || null,
                qty: item.qty,
                free_qty: item.free_qty,
                unit_id: item.product.unit?.id || "",
                unit_name: item.product.unit?.name || "",
                sales_rate: item.sales_rate,
                standard_purity: item.product?.standard_purity || 0,
                present_purity: item.present_purity|| 0,
                rate: item.rate,
                total: item.qty * item.rate,
              });
            });
            this.remarks.value.value = purOrder.remarks ? purOrder.remarks : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            console.error("Failed to fetch rfq:", error);
          });
      });
    } else {
      this.shipping_date.value.value = new Date();
      this.receive_date.value.value = new Date();
      this.purchase_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>

<style scoped>
.po-receive-cost-table :deep(table){min-width:1550px}
</style>
